import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getAppConfig } from '../../config/config';
import { prepareAuthHeaders } from '../../config/authConfig';
import { Standards } from '../../types/domainTypes';

export const standardsApi = createApi({
  reducerPath: 'standardsApi',
  baseQuery: fetchBaseQuery({ prepareHeaders: prepareAuthHeaders }),
  tagTypes: ['Standards'],
  endpoints: (builder) => ({
    getStandards: builder.query<Standards[], null>({
      query: () => {
        const url = `${getAppConfig().apiUrl}/Standards`;

        return { url: url, method: 'GET' };
      },
    }),
  }),
});

export const { useGetStandardsQuery, util } = standardsApi;
